export default {
    cars(state){
        return state.cars;
    },

    pages(state){
        return state.pages;
    }
}